import React, { useState } from "react";
import { Modal, Button, Spin } from "antd";
import "react-codes-input/lib/react-codes-input.min.css";
import PincodeInput from "../PincodeInput";

export function TransactionResume({
  title,
  message,
  fees,
  totalAmount,
  handleCancel,
  handlePay,
  status,
}) {
  const [pin, setPin] = useState("");

  return (
    <Modal
      title={title}
      visible={status}
      centered
      footer={null}
      closable={false}
      onCancel={handleCancel}
      className="resume-transaction"
    >
      <div style={{ padding: "0px 0px" }}>
        <p>{message}</p>
        <p className="fees">
          Frais: {parseInt(fees)} FCFA <br />
        </p>
        {totalAmount > 0 && (
          <p style={{ fontWeight: "bold", color: "#00b1c6" }}>
            Montant total: {parseInt(totalAmount)} FCFA
          </p>
        )}

        <p style={{ padding: "0px 0px" }}>
          Entrer votre code pin pour valider la transaction
        </p>
        <div className="pincode">
          <PincodeInput length={4} onChange={(res) => setPin(res)} />
        </div>

        <Button
          style={{ margin: "5px" }}
          className="btn btn-primary"
          onClick={() => handleCancel()}>
          Annuler
        </Button>

        <Button
          style={{ margin: "5px" }}
          className="btn btn-secondary"
          // disabled={pin ? false : true}
          onClick={() => handlePay(pin)}>
          Valider
        </Button>
      </div>
    </Modal >
  );
}
export default TransactionResume;
